/**
 * Small presentational helpers shared by the player row and the squad lists.
 */

import type { Role } from '@ipl-sim/engine-cricket';

/**
 * The tag printed on a card. The data code for a bowler is `BWL`; "BOWL" is
 * what a cricket follower reads without pausing, and the extra letter costs
 * nothing at this size. The code is what `data-role` carries, so the colour
 * mapping and the label never have to agree.
 */
export function roleLabel(role: Role): string {
  return role === 'BWL' ? 'BOWL' : role;
}

/**
 * Rating tier, which drives the colour and glow on a figure. Only 90+ glows.
 * Returns '' below 80 so the attribute selector simply does not match.
 */
export function tier(value: number | null | undefined): '' | '80' | '90' | '95' {
  if (value == null) return '';
  if (value >= 95) return '95';
  if (value >= 90) return '90';
  if (value >= 80) return '80';
  return '';
}
